<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir item"
            @click.stop="confirmarExcluir()"
        ></i>
    </span>
</template>

<script>
import BaseConhecimentoServicos from './BaseConhecimentoServicos'

export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de Item',
                html: `Confirma a exclusão do item <b>${this.item.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            BaseConhecimentoServicos.excluirItem(this.item.itemId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Item excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarListaItens', response.data)
                        } else {
                            this.$toast.error(
                                'Erro ao excluir item.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    }
}
</script>
